import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// Monitoring d'erreurs (Sentry) — désactivé par défaut.
// Pour l'activer : créez un projet sur sentry.io, récupérez votre DSN
// et décommentez le bloc ci-dessous en y mettant VOTRE dsn.
//
// import * as Sentry from "@sentry/react";
// Sentry.init({
//   dsn: "VOTRE_DSN_SENTRY",
//   integrations: [Sentry.browserTracingIntegration()],
//   tracesSampleRate: 1.0,
// });

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
